// import start_main_logo from "../../images/logo7.png";
import start_main_logo from "../../images/dZen_3.png";
import React from "react";

class Start_Main_Logo extends React.Component {
    render() {
        return(
            <div className="start_main_logo_div">
                <img className="start_main_logo" src={start_main_logo} alt="start_main" />
            </div>
        )
    }
}

export default Start_Main_Logo;